import 'owl.carousel';
import 'magnific-popup';

jQuery( document ).ready(function($) {
    $('.hero-carousel').owlCarousel({
        loop:true,
        margin:0,
        items: 1,
        nav:false,
        dots: false,
        autoplay: true, 
        autoplayTimeout: 6000,
        autoplaySpeed: 3000,
        autoplayHoverPause: true,
    });

    $('#menu-toggle').on('click', function(e){
        e.preventDefault();
        $('#menu').toggleClass('open');
        $('#menu-toggle').toggleClass('open');
    });

    $('.blocks-gallery-item a').magnificPopup({
        type: 'image'
    });

    $('.translate-btn').on('click', function(){
        doGTranslate('en|' + 'sp');
    });
}); 